export default __webpack_public_path__ + "static/media/Link.58dc2563.svg";